/**
 * Homeschool, Handled. — offer constants.
 *
 * Every value that blocks publication lives here so it can be changed in one
 * place. Items marked PENDING are decisions the owner still has to make; the
 * defaults below are the recommended ones from the copy brief.
 */

/** PENDING #1 — guarantee window. Default: 7 days, 100%, no questions asked. */
export const GUARANTEE_DAYS = 7

export const PRICE = '$27'

/** PENDING #2 — anchor must be a price you will actually charge. */
export const REGULAR_PRICE = '$97'
export const STACKED_VALUE = '$176'
export const SAVINGS = '$70'

/** PENDING #3 — bonus prices must add up to BONUS_VALUE. 9+19+19+17+15 = 79. */
export const BONUS_VALUE = '$79'

/**
 * PENDING #4 — urgency treatment.
 * 'none'         → Option B: no urgency, safe to launch tomorrow (recommended).
 * 'launch-price' → Option A: only if the date and the increase are real.
 */
export type UrgencyVariant = 'none' | 'launch-price'
export const LAUNCH_PRICE_ENDS = '[REAL DATE]'
export const PRICE_AFTER_LAUNCH = '$47'

/**
 * PENDING — pilot-cohort proof for the dark stats bar.
 * Leave as null until the number is real and countable. When you set it, it
 * replaces the "6 + 5" stat (the one the mini-badges already cover).
 * e.g. { value: '31', label: 'Families running it in the pilot group' }
 *      { value: '4.8/5', label: 'Average rating from the pilot group' }
 */
export const PILOT_PROOF: { value: string; label: string } | null = null

/** PENDING #5 — delivery mechanism, quoted in FAQ 7. */
export const DELIVERY =
  'the download link appears on the confirmation page and lands in your inbox'

/** PENDING #6 — checkout, support and legal. */
export const CHECKOUT_URL = 'https://homeschool-handled.impultienda.ar/checkout'
export const SUPPORT_EMAIL = 'REPLACE@your-domain.com'
export const SOCIAL_URL = '#social'
export const TERMS_URL = '#terms'
export const PRIVACY_URL = '#privacy'
